// extracted by mini-css-extract-plugin
module.exports = {"container":"popup_container__1SF7n","btndiv":"popup_btndiv__3sxLS","cancelbtn":"popup_cancelbtn__1xzo0"};